import React from "react";
import { RegionSelect } from "./RegionSelect";

interface Props {
    bottomSpacing?: true | false;
}

export const RelatedLocalCta: React.FC<Props> = ({ bottomSpacing = false }) => {
    return <RegionSelect bottomSpacing={bottomSpacing} />;
};
